{
  "splash": {
    "title": "Développé avec le support du Gouvernement du Canada"
  },
  "all-listings": {
    "disconnected": {
      "text": "Créé ton compte ou connecte-toi pour voir les ressources disponibles dans ACCÈS REFRAIN."
    },
    "needLogin": {
      "secondLine": "Créé ton compte ou connecte-toi pour voir les ressources disponibles dans ACCÈS REFRAIN."
    },
    "empty": {
      "offer": {
        "firstLine": "Débute ton aventure ici !",
        "primaryButtonText": "Publie une offre !",
        "secondLine": "Participe au catalogue en offrant des objets à prêter."
      },
      "invite": {
        "primaryButtonText": "Invite les autres membres",
        "secondLine": "Invite des membres ou publie une offre dans ton quartier."
      }
    },
    "banner": {
      "xmas": {
        "text": "Les Fêtes arrivent ! Aide les autres membres à trouver ces objets souvent demandés."
      }
    },
    "inviteOthersPrompt": {
      "ctaButton": "Invite les autres membres"
    },
    "postOfferPrompt": {
      "firstAfter": {
        "button": "Inviter les autres membres",
        "title": "Invite les autres membres !"
      },
      "third": {
        "title": "Demande aux autres membres"
      }
    }
  },
  "billboard": {
    "unauthenticatedTitle": "Crée un compte ou connecte-toi",
    "unauthenticatedTitle_2": "pour voir les ressources disponibles dans ACCÈS REFRAIN."
  },
  "common": {
    "appName": "ACCÈS REFRAIN",
    "appDownloadPrompt": {
      "guest": "Tu aimes ce que tu vois? Retrouve ACCÈS REFRAIN sur ton téléphone et reçois les nouvelles disponibilités près de chez toi",
      "qrCodeAccessibilityLabel": "Code QR pour télécharger l’application ACCÈS REFRAIN"
    }
  },
  "contact-information": {
    "prompt": "Ajoute le code postal du festival afin de voir quels objets sont disponibles à proximité.",
    "title": "Ton adresse"
  },
  "contact-us": {
    "firstParagraph": "Le service aux membres d'ACCÈS REFRAIN est accessible par courriel et messagerie. Nous te répondrons le plus rapidement possible.",
    "faqLink": "https://lerefrain.com/fr/faq-acces-refrain",
    "chatPrompt": {
      "bugReport": "Salut ! 😊\n\nMerci de nous expliquer ce qui ne va pas.",
      "suggestion": "Salut ! 😊\n\nOn est toujours ouverts aux suggestions. Merci de nous aider à améliorer notre service.\n\nMerci !"
    }
  },
  "credentials": {
    "activationCodeFieldHelp": "Un code d'invitation est nécessaire afin d'utiliser ACCÈS REFRAIN. Pour en obtenir un, rends-toi sur <a>l'espace membre Refrain</a>.",
    "activationCodeFieldHelpLink": "https://lerefrain.com/fr/connexion"
  },
  "guidelines": {
    "fifthParagraph": "Ne pas utiliser ACCÈS REFRAIN pour vendre des objets.",
    "startingKit": "Je veux recevoir la <startingKitLink>Trousse de départ</startingKitLink> par la poste pour recruter les autres membres (optionnel)"
  },
  "impact": {
    "levels": {
      "0": {
        "description-completed": "Rejoint ACCÈS REFRAIN",
        "title": "Explorateur"
      }
    }
  },
  "introModal": {
    "title": "Cher {{name}},",
    "first": "Bienvenue sur l’application de partage et découvre le <strong>vaste catalogue de ressources matérielles disponibles !</strong>",
    "second": "<strong>Partager est une preuve de confiance</strong> : plus tu prêtes, plus les autres auront envie de te prêter !",
    "third": "<strong>Sache que moins de 0,1% de tous les partages</strong> engendrent un bris. Et ce n’est pas de mauvaise foi. C’est juste normal quand les objets sont un peu plus utilisés.",
    "notInsurable": {
      "community": "<strong>C’est l’occasion parfaite pour faire connaissance avec les autres membres</strong>, et faire un pas vers un monde durable."
    },
    "welcome": {
      "withWho": {
        "enterprise": "tes collègues et les autres membres",
        "municipal": "les autres membres",
        "municipal_closed": "les autres membres",
        "realestate": "les autres membres"
      }
    }
  },
  "landing-page": {
    "popularInterests": "Catégories",
    "multipleOfferCard": {
      "title": "Tu as sûrement ces objets !"
    },
    "immature": {
      "referral": {
        "button": "Invite les autres membres"
      }
    },
    "requests": {
      "emptyState": {
        "subtitle": "Nous te préviendrons si les autres membres ont besoin d’aide"
      }
    }
  },
  "my-information": {
    "firstNameFieldLabel": "Nom du festival",
    "credentialInformationTitle": "Compte et sécurité",
    "personalInformationTitle": "Informations du profil"
  },
  "my-personal-information": {
    "firstNameFieldLabel": "Nom du festival",
    "firstNameFieldPlaceholder": "ex. Festival du Bon-Vent de Ste-Pépitte",
    "title": "Informations du profil"
  },
  "my-plan": {
    "businessPlan": {
      "firstParagraph": {
        "enterprise": "Ton abonnement à ACCÈS REFRAIN est une gracieuseté du Refrain."
      },
      "title": {
        "enterprise": "Abonnement ACCÈS REFRAIN"
      }
    },
    "refrainPlan": {
      "firstParagraph": "",
      "title": "Abonnement ACCÈS REFRAIN"
    },
    "noEnd": "Cet abonnement est valide tant que tu es membre du Refrain.",
    "design": {
      "freeBorrowDescription": "Emprunte ton premier objet aux autres membres gratuitement",
      "unlimitedLendingDescription": "Publie des offres et prête tes objets aux autres membres autant de fois que tu le souhaites"
    }
  },
  "new": {
    "itemInformationSection": {
      "nameFieldPlaceholder": "ex: Console de son",
      "descriptionFieldPlaceholder": {
        "offer": "Marque, dimensions, couleur, poids, état, année d’acquisition, conditions d’emprunt, spécificités de l’objet ...",
        "request": "Marque, dimensions, couleur, poids, état, année d’acquisition, conditions d’emprunt, spécificités de l’objet ..."
      }
    }
  },
  "notifications": {
    "introModal": {
      "intro": {
        "title": "Bienvenue dans le club",
        "body": "Découvre ACCÈS REFRAIN !"
      }
    },
    "welcome": "Bienvenue sur ACCÈS REFRAIN !",
    "welcomeMessage": "Merci de nous faire confiance.",
    "rate": {
      "borrower": {
        "message": "Ton avis est important pour nous et pour les autres membres d'ACCÈS REFRAIN."
      },
      "lender": {
        "message": "Ton avis est important pour nous et pour les autres membres d'ACCÈS REFRAIN."
      }
    },
    "loanReciprocity": {
      "message": "Publie les objets que tu utilises peu et fais-en profiter les autres membres."
    }
  },
  "one-channel": {
    "levelModal": {
      "superSharer": {
        "message": "Tu as augmenté ton impact en réalisant 5 partages ! Tu accèdes maintenant au niveau ultime : <strong>Super Partageur</strong> et un exemple à suivre pour les autres membres d'ACCÈS REFRAIN.\n\nBravo! À chaque partage, tu grandis ton impact pour un avenir plus vert."
      }
    },
    "howItWorks": {
      "borrow": {
        "step2": "<bold>Propose</bold> des dates d'emprunt, <bold>attends la confirmation</bold> de l’autre membre puis <bold>planifiez le ramassage</bold> ensemble",
        "step3": "<bold>Récupère l'objet</bold> chez l’autre membre ou dans un lieu public sécuritaire. <bold>Aucun échange d'argent, c'est gratuit !</bold>"
      },
      "lend": {
        "step3": "<bold>Prête l'objet</bold> à l’autre membre. <bold>Aucun échange d'argent, c'est gratuit !</bold>"
      }
    }
  },
  "one-listing": {
    "needFoundModal": {
      "step2": {
        "gotoSelectLender": "Le besoin a été comblé sur ACCÈS REFRAIN"
      }
    }
  },
  "personal-information": {
    "firstNameFieldLabel": "Nom du festival",
    "firstNameFieldPlaceholder": "ex. Festival du Bon-Vent de Ste-Pépitte",
    "pictureFieldSubtitle": "Cette image sera affichée dans tes annonces et ton profil.",
    "pictureFieldTitle": "Ajouter une image du logo du festival",
    "title": "Informations du profil"
  },
  "privacy": {
    "link1": "https://lerefrain.com/fr/acces-refrain-conditions-dutilisation",
    "link2": "https://lerefrain.com/fr/acces-refrain-politique-de-confidentialite",
    "line3": "d'ACCÈS REFRAIN."
  },
  "quick-new-thanks": {
    "bodyText": "Tu viens de contribuer à enrichir le catalogue d'<strong>ACCÈS REFRAIN</strong> ! \n\nTu peux modifier tes offres à tout moment dans ton centre de partage."
  },
  "ratings": {
    "notGreat": {
      "ctaButton": "Contacter ACCÈS REFRAIN"
    }
  },
  "tutorial": {
    "multipleOffers": {
      "step1": {
        "text": "En offrant tes objets, tu encourages même les festivals les plus timides à demander."
      }
    },
    "publishOffers": {
      "step2": {
        "text": "En offrant tes objets, tu encourages même <strong>les autres membres les plus timides</strong> à demander. Tu peux toujours prêter tes objets, <strong>même sans abonnement</strong>.\n\nAppuie sur l’icône pour continuer. (2/5)"
      },
      "step2AltCorp": {
        "text": "En offrant tes objets, tu encourages même <strong>les autres membres les plus timides</strong> à demander.\n\nAppuie sur l’icône pour continuer. (2/5)"
      }
    }
  },
  "festival": {
    "nextEdition": "Prochaine édition",
    "changeLater": "Vous pourrez modifier la date plus tard dans le profil",
    "startDate": "Date de début",
    "chooseDate": "Confirmer votre date",
    "address": "Adresse",
    "profileTitle": "Date de la prochaine édition",
    "missingDate": "Date à confirmer",
    "expired": "Expiré",
    "edit": "Modifier",
    "editTitle": "Modifier la date de la prochaine édition",
    "cancel": "Annuler",
    "save": "Enregistrer",
    "close": "Fermer",
    "dateRequired": "Sélectionnez une date de début à partir d’aujourd’hui.",
    "saveError": "La date n’a pas pu être enregistrée. Veuillez réessayer.",
    "initialTitle": "Quand démarre la prochaine édition ?",
    "initialMessage": "Indiquez la date de début de la prochaine édition de votre festival.",
    "reminderTitle": "En route pour la prochaine édition !",
    "reminderMessage": "Il est temps de mettre à jour la date de la prochaine édition de votre festival.",
    "updateDate": "Mettre à jour la date",
    "later": "Plus tard",
    "signupTitle": "Votre festival"
  },
  "presentPartageClub": {
    "community": {
      "headerText": "Accès Refrain, c'est l'application de <strong>partage d’équipements</strong> entre festivals",
      "footerText": "Ne vous <strong>limitez</strong> pas aux possessions de votre organisation"
    },
    "accessMore": {
      "headerText": "Sur Accès Refrain, tu accèdes à une <strong>abondance d’équipements</strong>.",
      "footerText": "Matériels, scènes, etc. : ici, vous trouvez <strong>vraiment tout.</strong>"
    },
    "offerMore": {
      "headerText": "Sur Accès Refrain, <strong>partager</strong> c’est <strong>aider</strong> d’autres festivals tout en <strong> optimisant ses ressources</strong>.",
      "footerText": "Faite <strong>profiter</strong> les autres festivals de vos équipements <strong>trop peu utilisés.</strong>"
    }
  },
  "help": {
    "guestCta": {
      "text": "Rejoins les autres membres et découvre tout ce que tu peux emprunter près de chez toi."
    },
    "borrower": {
      "steps": {
        "catalog": {
          "text": "Cherche un objet dans le catalogue ou crée un besoin visible par les autres membres"
        },
        "meeting": {
          "text": "Propose et confirme des dates d'emprunt et de ramassage avec l'autre membre"
        },
        "pickup": {
          "text": "Rencontre l'autre membre à son domicile ou dans un lieu public sécuritaire. <strong>Aucun échange d'argent, c'est gratuit !</strong>"
        }
      }
    },
    "lender": {
      "steps": {
        "share": {
          "text": "Rencontre l'autre membre à ton domicile ou dans un lieu public sécuritaire pour lui donner l'objet. <strong>Aucun échange d'argent, c'est gratuit !</strong>"
        }
      }
    }
  },
  "free-sub": {
    "inviteButtonText": "Inviter les autres membres",
    "spreadTheLoveText": "Parle-en aux autres membres pour qu’eux.elles aussi puissent profiter de l’offre spéciale !"
  },
  "invite": {
    "referralProgram": {
      "shareText": "Salut !\n\nJ’utilise ACCÈS REFRAIN, une app pour partager des objets du quotidien. C’est super pratique et je suis sûr·e que tu vas aimer. Rejoins-moi :\n\n{{url}}"
    },
    "referralProgram202506": {
      "shareText": "Salut !\n\nJ’utilise ACCÈS REFRAIN, une app pour partager des objets du quotidien. C’est super pratique et je suis sûr·e que tu vas aimer. Rejoins-moi :\n\n{{url}}"
    },
    "shareText": "Salut !\n\nJ’utilise ACCÈS REFRAIN, une app pour partager des objets du quotidien. C’est super pratique et je suis sûr·e que tu vas aimer. Rejoins-moi :\n\n{{url}}",
    "title": "Invite les autres membres ou tes proches !"
  },
  "loans": {
    "past": {
      "savings": {
        "header": {
          "lending": "Économisé par les autres membres grâce à toi"
        }
      }
    }
  },
  "my-impact-financial": {
    "empty": {
      "lending": {
        "secondLine": "Partage tes objets et vois combien d'argent tu permets aux membres d'économiser !"
      }
    },
    "emptyByTransaction": {
      "lend": {
        "lending": {
          "secondLine": "Partage tes objets et vois combien d'argent tu permets aux membres d'économiser !"
        }
      }
    }
  },
  "my-neighbourhood": {
    "radiusDescription": "Ton rayon te permet de partager tes annonces dans un périmètre limité de ton quartier. Les membres habitant hors de cette zone ne pourront pas voir tes annonces."
  },
  "payment": {
    "modal": {
      "firstParagraph": "Merci de ta confiance. Grâce à ton abonnement, tu peux maintenant emprunter et prêter des objets aux autres membres sans limite."
    }
  },
  "posts": {
    "feed": {
      "endOfFeed": {
        "description": "Un objet emprunté, une belle rencontre…\nPartage ton histoire avec les autres membres."
      }
    },
    "storyComposer": {
      "neighbour": "un membre"
    }
  },
  "presentCommunity": {
    "newFlow": {
      "oneFreeBorrowDescription": "Emprunte ton premier objet aux autres membres gratuitement",
      "unlimitedLendingDescription": "Publie des offres et prête tes objets aux autres membres autant de fois que tu le souhaites"
    }
  },
  "profile-overview": {
    "inviteNeighboursButtonLabel": "Inviter des membres"
  },
  "recommendations": {
    "urgent-needs": {
      "title": "Aide les autres membres !"
    }
  },
  "streak": {
    "contributions": {
      "add_avatar": {
        "description": "Une photo de profil rassure les autres membres et te rend reconnaissable dans le quartier."
      },
      "dismiss_request": {
        "title": "Essaye d'aider les autres membres"
      },
      "publish_offer": {
        "description": "Publie un objet spécifique, ou choisis parmi les objets suggérés, déjà proposés par les autres membres !"
      },
      "send_message": {
        "description": "Brise la glace! Écris à un membre pour proposer ton aide ou en savoir plus sur une annonce."
      }
    },
    "neighbourhoodFirstShare": "Dans ton quartier, <strong>{{percent}}% des autres membres</strong> ont fait leur premier partage <strong>en moins d'une semaine</strong>.",
    "objectiveDetails": "L’objectif du mois est déterminé en fonction du nombre de membres partageur·euse·s autour de toi et de la maturité de ton quartier.",
    "seriesDetails": "Pour garder la flamme du partage active, toi et les autres membres devez atteindre l’objectif de partages indiqué pour le mois.",
    "tips": {
      "helpNeighbours": {
        "title": "Essaye d'aider les autres membres"
      }
    }
  }
}
